/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Portals_Vr_HintInputs */

const cs_property_portals_vr_hint = /** @type {(inputs: Property_Portals_Vr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkazy na Matterport / virtuální prohlídku a panorama Mapy.cz zobrazené na portálech.`)
};

const en_property_portals_vr_hint = /** @type {(inputs: Property_Portals_Vr_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matterport / virtual walkthrough and Mapy.cz panorama links shown on portals.`)
};

/**
* | output |
* | --- |
* | "Matterport / virtual walkthrough and Mapy.cz panorama links shown on portals." |
*
* @param {Property_Portals_Vr_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_portals_vr_hint = /** @type {((inputs?: Property_Portals_Vr_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Portals_Vr_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_portals_vr_hint(inputs)
	return cs_property_portals_vr_hint(inputs)
});